<template>
  <div class="searchRegulationsContents">
    <div v-if="searchContents == null">
      <div class="spin">
        <font-awesome-icon icon="compass" />
      </div>
      <div>
        加载中，请稍候......
      </div>
    </div>
    <div v-else class="main">
      <el-row class="overview">
        <el-col :span="22">
          <span class="overview_text">
            共搜索到<span class="num">{{searchContents.length}}</span>法规中的<span class="num">{{num}}</span>个条款。
          </span>
          <span @click="downloadSearchResults()" class="show-xs-and-up-only">
            &nbsp;&nbsp;
            <a>
              <font-awesome-icon icon="arrow-alt-circle-down" />
            </a>
          </span>
        </el-col>
        <el-col :span="2" style="text-align:right">
          <el-dropdown trigger="click">
            <img src="static/images/1DING-MINLOG.svg" type="image/svg+xml" class="logo">
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="menu('home')">网站首页 / 常规搜索</el-dropdown-item>
              <el-dropdown-item @click.native="menu('advanceSearch')">高级搜索 / 精准搜索</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="menu('standards')" class="left show-md-and-up-only">国内标准 / 国际标准</el-dropdown-item>
              <el-dropdown-item @click.native="menu('regulations')" class="left show-md-and-up-only">法律法规 / 监管要求</el-dropdown-item> -->
              <el-dropdown-item divided @click.native="user('regulations')" class="left show-md-and-up-only">个人中心 / 消费记录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      <!-- 如果未能搜索到相关内容，提示尝试使用其他关键字 -->
      <div v-if="searchContents.length == 0">
        <p style="margin-top:0.3rem;">
          未能检索到与关键字相匹配的内容，请重试其他关键字或放宽搜索条件。
        </p>
        <p style="margin-top:0.1rem;">
          注：本网站每天不定时更新相关内容，您也可以稍后重试。
        </p>
      </div>
      <!-- 如果有返回搜索结果，则进行展示 -->
      <div v-else>
        <el-row :gutter="20" class="title show-xs-and-up-only">
          <el-col :span="4"><span class="label">条款号</span></el-col>
          <el-col :span="20 "><span class="label">条款内容</span></el-col>
        </el-row>
        <div class="results hideScrollbar show-xs-and-up-only">
          <div v-for="(item,index) in searchContents" :key="index">
            <div class="item">
              <a class='code' @click="openRegulations(item)">
                <span>{{index+1}}.&nbsp;&nbsp;</span>
                <span>{{item.regulations_name}}</span>
              </a>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <a @click="downloadRegulations(item)">
                <font-awesome-icon icon="arrow-alt-circle-down" />
              </a>
            </div>
            <div v-for="(itm,idx) in item.contents" :key="idx">
              <el-row :gutter="20" v-if="itm.clause_contents">
                <el-col :span="4">
                  <span v-if="itm.clause_title">{{itm.clause_title}}</span>
                  <span v-else-if="itm.clause_contents !==null && itm.clause_contents.substring(0,1) ==='第'">
                    {{itm.clause_contents.match("第[^\x00-\xff]{1,5}条")}}
                  </span>
                  <div v-else>
                    &nbsp;
                  </div>
                </el-col>
                <el-col :span="20">
                  <div v-html="itm.clause_contents"></div>
                  <div v-if="itm.clause_table" v-html="item.clause_table"></div>
                  <div v-if="itm.clause_image">
                    <div v-for="(img,indx) in item.clause_image.split(',')" :key="indx">
                      <embed :src="'static/images/' + img" type="image/svg+xml" class="image" />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="results hideScrollbar show-xs-down-only">
          <div v-for="(item,index) in searchContents" :key="index">
            <div class="xsTitle" @click="openRegulations(item)">
              <span>{{index+1}}.</span>
              <span>{{item.regulations_name}}</span>
            </div>
            <div v-for="(itm,idx) in item.contents" :key="idx">
              <div class="xsItem">
                <span v-if="itm.clause_title">{{itm.clause_title}}</span>
                <span v-else-if="itm.clause_contents !==null && itm.clause_contents.substring(0,1) ==='第'">
                  {{itm.clause_contents.match("第[^\x00-\xff]{1,5}条")}}
                </span>
              </div>
              <div v-html="itm.clause_contents"></div>
              <div v-if="itm.clause_table" v-html="itm.clause_table"></div>
              <div v-if="item.clause_table" v-html="item.clause_table"></div>
        <div
          v-if="item.clause_table2"
          class="dev"
        >
          <table
            border="1"
            width=100%
            class="table"
            cellpadding="5"
          >
            <tr
              v-for="(item,index) in JSON.parse(item.clause_table2).children"
              :key="'d' + index"
            >
              <template v-for="(value,key,index) in item">
                <td
                  :key="'d_d'+index"
                  v-html='value.value'
                  :rowspan="value.rowspan != -1 ? value.rowspan : ''"
                  :colspan="value.colspan != -1 ? value.colspan : ''"
                  v-if="value.rowspan != '-1' && value.colspan != '-1'"
                  :class="value.head ? 'head' : ''"
                >
                </td>
              </template>
            </tr>
          </table>
        </div>
              <div v-if="itm.clause_image">
                <div v-for="(img,indx) in item.clause_image.split(',')" :key="indx">
                  <embed :src="'static/images/' + itm" type="image/svg+xml" class="image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from "@/misc/bus.js";
  import axios from "axios";
  import global_ from "@/misc/global.vue";
  export default {
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.$store.dispatch(
          "regulations/searchContents",
          vm.$route.query.keywords
        );
      });
    },
    mounted() {
      for (var i = 0; i < this.num; i++) {
        this.$set(this.open, i, true);
      }
    },
    computed: {
      searchContents() {
        return this.$store.state.regulations.searchContents;
      },
      keywords() {
        return this.$route.query.keywords;
      },
      num() {
        var num = 0
        if (this.searchContents) {
          for (var i = 0; i < this.searchContents.length; i++) {
            for (var j = 0; j < this.searchContents[i].contents.length; j++) {
              if (j == 0) {
                num++
              } else if (this.searchContents[i].contents[j].clause_code3 != this.searchContents[i]
                .contents[j - 1]
                .clause_code3) {
                num++
              }
            }
          }
        }
        return num
      }
    },
    methods: {
      menu(params) {
        const {
          href
        } = this.$router.resolve({
          path: "/" + params
        });
        window.open(href, "_blank");
      },
      user() {
        this.$store.dispatch("users/getConsumptionHistory");
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
      },
      openRegulations(params) {
        axios
          .get(global_.BAK_URL + "getRegulationsDescription/", {
            params: {
              keywords: params.regulations_id
            },
            async: false
          })
          .then(response => {
            const {
              href
            } = this.$router.resolve({
              path: "/showRegulations",
              query: {
                committee: response.data[0].committee,
                regulations_code: response.data[0].regulations_code,
                regulations_name: response.data[0].regulations_name,
              }
            });
            window.open(href, "_blank");
          });
      },
      downloadRegulations(params) {
        this.$store.dispatch("users/getConsumptionHistory")
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false);
        this.$store.dispatch('order/setRechargeInfo', 5000)
        this.$store.dispatch("order/setOnceInfo", {
          description: params.contents[0].regulations_name,
          category: "regulations_download",
          code: params.contents[0].regulations_id,
          total_fee: 98, //单位分
          order_number: new Date().getTime(),
          body: "法规下载" // 发给微信端的订单描述
        });
      },
      downloadSearchResults() {
        this.$store.dispatch("users/getConsumptionHistory")
        this.$store.dispatch("users/getUserInfo");
        Bus.$emit("showUserCenter", true);
        Bus.$emit("paied", false)
        this.$store.dispatch("order/setOnceInfo", {
          description: this.keywords,
          category: "regulations_search_download",
          code: this.keywords.replace(/：/g, ":").replace(/，/g, ",").replace(/[nNyYsSoOiI]:/g, 'x:').replace(
            /[cC]:/g, 'c:'),
          total_fee: 498, //单位分
          order_number: new Date().getTime(),
          body: "标准搜索结果下载" // 发给微信端的订单描述
        });
      }
    }
  };
</script>

<style scoped>
  .searchRegulationsContents {
    width: 100%;
    min-height: 100vh;
    padding: 0.2rem;
    text-align: center;
  }

  .searchRegulationsContents .main {
    text-align: left
  }

  .searchRegulationsContents .overview {
    border-bottom: 0.01rem solid gray
  }

  .searchRegulationsContents .overview_text {
    position: relative;
    padding: 0.05rem 0;
    font-size: 0.15rem !important;
    font-weight: 900 !important;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .searchRegulationsContents .overview_text:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 6px;
    left: 0;
    bottom: -3px;
    background: #aa0000;
  }

  .searchRegulationsContents .num {
    background-color: #aa0000;
    color: white;
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    letter-spacing: 0.01rem;
    padding: 0rem 0.05rem;
    margin: 0 0.1rem;
  }

  .searchRegulationsContents .label {
    color: black;
    padding: 0.05rem;
    font-weight: 900
  }


  .searchRegulationsContents .logo {
    margin: -0.05rem 0;
    height: 0.2rem;
    cursor: pointer;
  }

  .searchRegulationsContents .title {
    margin-top: 0.1rem;
    padding: 0.05rem;
  }

  .searchRegulationsContents .results {
    margin-top: 0.1rem;
    padding: 0.05rem 0.05rem 0.6rem 0.05rem;
    height: calc(100vh - 1.1rem);
  }

  .searchRegulationsContents .item {
    margin-top: 0.1rem;
  }

  .searchRegulationsContents .code,
  .searchRegulationsContents .name {
    border-bottom: 0.02rem solid #efefef;
  }

  .searchRegulationsContents .xsTitle {
    margin-top: 0.2rem;
    background-color: #ccc;
    border-radius: 0.02rem;
    padding: 0.05rem;
    color: black
  }

  .searchRegulationsContents .xsItem {
    margin-top: 0.1rem;
  }

  .searchRegulationsContents .xsLabel {
    background-color: #666;
    padding: 0.05rem 0.05rem 0.05rem 0
  }

  .dev {
    margin: 0.1rem;
    /* text-align: center; */
  }

  .table {
      border-collapse: collapse;
  }

  .table .head {
      font-weight: 900;
      text-align: center
  }
</style>

<style>
  .searchRegulationsContents .ivu-spin {
    color: #efefef;
  }

  .searchRegulationsContents .ivu-spin-dot {
    background-color: #efefef;
  }
</style>

<style>
  .searchRegulationsContents .ivu-spin {
    color: #efefef;
  }

  .searchRegulationsContents .ivu-spin-dot {
    background-color: #efefef;
  }